import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/zeit/c54a7b7/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2 {...{
      "id": "october-2019"
    }}>{`October 2019`}</h2>
    <h3 {...{
      "id": "carboncolors1050"
    }}>{`@carbon/colors@10.5.0`}</h3>
    <h4 {...{
      "id": "new-features"
    }}>{`New features`}</h4>
    <ul>
      <li parentName="ul">{`feat(colors): update colors to match V2 palette (#3957) (`}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/commit/ed202f8f6"
        }}><inlineCode parentName="a">{`ed202f8f6`}</inlineCode></a>{`)`}</li>
    </ul>
    <h4 {...{
      "id": "housekeeping"
    }}>{`Housekeeping`}</h4>
    <ul>
      <li parentName="ul">{`chore(release): update package versions (#4265) (`}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/commit/346e93543"
        }}><inlineCode parentName="a">{`346e93543`}</inlineCode></a>{`)`}</li>
      <li parentName="ul">{`chore(release): update package versions (#4262) (`}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/commit/8983ed788"
        }}><inlineCode parentName="a">{`8983ed788`}</inlineCode></a>{`)`}</li>
      <li parentName="ul">{`chore(colors): add color palette source files (#4206) (`}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/commit/4d1781eee"
        }}><inlineCode parentName="a">{`4d1781eee`}</inlineCode></a>{`)`}</li>
      <li parentName="ul">{`chore(release): update package versions (#4139) (`}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/commit/1a435757c"
        }}><inlineCode parentName="a">{`1a435757c`}</inlineCode></a>{`)`}</li>
    </ul>
    <h3 {...{
      "id": "carbon-components1070"
    }}>{`carbon-components@10.7.0`}</h3>
    <h4 {...{
      "id": "new-features-1"
    }}>{`New features`}</h4>
    <ul>
      <li parentName="ul">{`feat(toggle): add aria-label and label text props to skeletons (#4204) (`}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/commit/fef8eb9f4"
        }}><inlineCode parentName="a">{`fef8eb9f4`}</inlineCode></a>{`)`}</li>
      <li parentName="ul">{`feat(components,themes): add enable-css-custom-properties feature flag (#4100) (`}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/commit/d8d93e366"
        }}><inlineCode parentName="a">{`d8d93e366`}</inlineCode></a>{`)`}</li>
      <li parentName="ul">{`feat(themes): update build step to emit prefixed custom properties (`}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/commit/0b0599e6e"
        }}><inlineCode parentName="a">{`0b0599e6e`}</inlineCode></a>{`)`}</li>
      <li parentName="ul">{`feat(file-uploader): add drop and drop file uploader (#3873) (`}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/commit/0074e2219"
        }}><inlineCode parentName="a">{`0074e2219`}</inlineCode></a>{`)`}</li>
      <li parentName="ul">{`feat(link): introduce inline variant (#3859) (`}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/commit/f167fd6fb"
        }}><inlineCode parentName="a">{`f167fd6fb`}</inlineCode></a>{`)`}</li>
      <li parentName="ul">{`feat(FileUploader): add drag and drop file uploader (#3872) (`}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/commit/8a4fae72c"
        }}><inlineCode parentName="a">{`8a4fae72c`}</inlineCode></a>{`)`}</li>
      <li parentName="ul">{`feat(floating-menu): add focus wrap element to components (#3652) (`}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/commit/34d1fddcf"
        }}><inlineCode parentName="a">{`34d1fddcf`}</inlineCode></a>{`)`}</li>
      <li parentName="ul">{`feat(TooltipIcon): port vanilla WCAG 2.1 fixes (#3842) (`}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/commit/aeacad436"
        }}><inlineCode parentName="a">{`aeacad436`}</inlineCode></a>{`)`}</li>
    </ul>
    <h4 {...{
      "id": "bug-fixes"
    }}>{`Bug fixes`}</h4>
    <ul>
      <li parentName="ul">{`fix(components): make sure font weight is loaded (#4160) (`}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/commit/f73d62a81"
        }}><inlineCode parentName="a">{`f73d62a81`}</inlineCode></a>{`)`}</li>
      <li parentName="ul">{`fix(dropdown): update overflow style rules for ie, edge, and safari support (#4132) (`}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/commit/a48e6bd66"
        }}><inlineCode parentName="a">{`a48e6bd66`}</inlineCode></a>{`)`}</li>
      <li parentName="ul">{`fix(accordion): top align accordion headings (#4125) (`}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/commit/1974a1e86"
        }}><inlineCode parentName="a">{`1974a1e86`}</inlineCode></a>{`)`}</li>
      <li parentName="ul">{`fix(components): call carbon—theme to keep themes in sync (`}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/commit/14cbc219d"
        }}><inlineCode parentName="a">{`14cbc219d`}</inlineCode></a>{`)`}</li>
      <li parentName="ul">{`fix(modal): use focus theme token for close button border color on focus (#4078) (`}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/commit/d96efd6d5"
        }}><inlineCode parentName="a">{`d96efd6d5`}</inlineCode></a>{`)`}</li>
      <li parentName="ul">{`fix(button): add higher contrast danger button color token to all themes (#4037) (`}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/commit/7c8fd431a"
        }}><inlineCode parentName="a">{`7c8fd431a`}</inlineCode></a>{`)`}</li>
      <li parentName="ul">{`fix(toggle): update colors (#4038) (`}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/commit/9ac1eef87"
        }}><inlineCode parentName="a">{`9ac1eef87`}</inlineCode></a>{`)`}</li>
      <li parentName="ul">{`fix(button): vertically align to top by default (#3983) (`}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/commit/06b15f3c6"
        }}><inlineCode parentName="a">{`06b15f3c6`}</inlineCode></a>{`)`}</li>
      <li parentName="ul">{`fix(date-picker): update month UI upon manual input (#3979) (`}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/commit/cccb54c56"
        }}><inlineCode parentName="a">{`cccb54c56`}</inlineCode></a>{`)`}</li>
      <li parentName="ul">{`fix(form): remove italic from helper text (#3977) (`}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/commit/dfbeb8dce"
        }}><inlineCode parentName="a">{`dfbeb8dce`}</inlineCode></a>{`)`}</li>
      <li parentName="ul">{`fix(dropdown): restore space bar and enter key item selection (#3926) (`}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/commit/fc2277328"
        }}><inlineCode parentName="a">{`fc2277328`}</inlineCode></a>{`)`}</li>
      <li parentName="ul">{`fix(skeleton): disable motion if prefers-reduced-motion is true (#3905) (`}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/commit/d9aede10e"
        }}><inlineCode parentName="a">{`d9aede10e`}</inlineCode></a>{`)`}</li>
      <li parentName="ul">{`fix(notification): fix low contrast markup (#3899) (`}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/commit/95e02b98b"
        }}><inlineCode parentName="a">{`95e02b98b`}</inlineCode></a>{`)`}</li>
    </ul>
    <h4 {...{
      "id": "documentation"
    }}>{`Documentation`}</h4>
    <ul>
      <li parentName="ul">{`docs(migration): update scss migration guide links (#4140) (`}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/commit/b2636f786"
        }}><inlineCode parentName="a">{`b2636f786`}</inlineCode></a>{`)`}</li>
      <li parentName="ul">{`docs(components): remove sassdoc annotation (#3916) (`}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/commit/884c2985c"
        }}><inlineCode parentName="a">{`884c2985c`}</inlineCode></a>{`)`}</li>
    </ul>
    <h4 {...{
      "id": "housekeeping-1"
    }}>{`Housekeeping`}</h4>
    <ul>
      <li parentName="ul">{`chore(release): update package versions (#4265) (`}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/commit/346e93543"
        }}><inlineCode parentName="a">{`346e93543`}</inlineCode></a>{`)`}</li>
      <li parentName="ul">{`chore(release): update package versions (#4262) (`}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/commit/8983ed788"
        }}><inlineCode parentName="a">{`8983ed788`}</inlineCode></a>{`)`}</li>
      <li parentName="ul">{`chore(release): update package versions (#4139) (`}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/commit/1a435757c"
        }}><inlineCode parentName="a">{`1a435757c`}</inlineCode></a>{`)`}</li>
      <li parentName="ul">{`test(components): update snapshots (`}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/commit/319b58952"
        }}><inlineCode parentName="a">{`319b58952`}</inlineCode></a>{`)`}</li>
      <li parentName="ul">{`chore(project): sync generated files (`}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/commit/f65266835"
        }}><inlineCode parentName="a">{`f65266835`}</inlineCode></a>{`)`}</li>
      <li parentName="ul">{`chore(project): check-in generated files (`}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/commit/9dab26827"
        }}><inlineCode parentName="a">{`9dab26827`}</inlineCode></a>{`)`}</li>
      <li parentName="ul">{`refactor(components): update test formatting (`}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/commit/59f999862"
        }}><inlineCode parentName="a">{`59f999862`}</inlineCode></a>{`)`}</li>
      <li parentName="ul">{`chore(project): remove custom eslint rules (#4027) (`}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/commit/58833d0bc"
        }}><inlineCode parentName="a">{`58833d0bc`}</inlineCode></a>{`)`}</li>
      <li parentName="ul">{`chore: removes dashed outline from modal close in firefox (#3984) (`}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/commit/8de0efcaf"
        }}><inlineCode parentName="a">{`8de0efcaf`}</inlineCode></a>{`)`}</li>
      <li parentName="ul">{`chore(data-table): mark sticky header experimental (#3949) (`}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/commit/11b87ab01"
        }}><inlineCode parentName="a">{`11b87ab01`}</inlineCode></a>{`)`}</li>
      <li parentName="ul">{`chore(react): update storybook and react (#3891) (`}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/commit/548a04168"
        }}><inlineCode parentName="a">{`548a04168`}</inlineCode></a>{`)`}</li>
    </ul>
    <h3 {...{
      "id": "carbonelements1070"
    }}>{`@carbon/elements@10.7.0`}</h3>
    <h4 {...{
      "id": "new-features-2"
    }}>{`New features`}</h4>
    <ul>
      <li parentName="ul">{`feat(components,themes): add enable-css-custom-properties feature flag (#4100) (`}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/commit/d8d93e366"
        }}><inlineCode parentName="a">{`d8d93e366`}</inlineCode></a>{`)`}</li>
    </ul>
    <h4 {...{
      "id": "bug-fixes-1"
    }}>{`Bug fixes`}</h4>
    <ul>
      <li parentName="ul">{`fix(form): remove italic from helper text (#3977) (`}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/commit/dfbeb8dce"
        }}><inlineCode parentName="a">{`dfbeb8dce`}</inlineCode></a>{`)`}</li>
    </ul>
    <h4 {...{
      "id": "housekeeping-2"
    }}>{`Housekeeping`}</h4>
    <ul>
      <li parentName="ul">{`chore(release): update package versions (#4265) (`}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/commit/346e93543"
        }}><inlineCode parentName="a">{`346e93543`}</inlineCode></a>{`)`}</li>
      <li parentName="ul">{`chore(release): update package versions (#4262) (`}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/commit/8983ed788"
        }}><inlineCode parentName="a">{`8983ed788`}</inlineCode></a>{`)`}</li>
      <li parentName="ul">{`chore(release): update package versions (#4139) (`}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/commit/1a435757c"
        }}><inlineCode parentName="a">{`1a435757c`}</inlineCode></a>{`)`}</li>
      <li parentName="ul">{`chore(project): sync generated files (`}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/commit/f65266835"
        }}><inlineCode parentName="a">{`f65266835`}</inlineCode></a>{`)`}</li>
      <li parentName="ul">{`chore(project): check-in generated files (`}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/commit/9dab26827"
        }}><inlineCode parentName="a">{`9dab26827`}</inlineCode></a>{`)`}</li>
    </ul>
    <h3 {...{
      "id": "carbonpictograms-react1070"
    }}>{`@carbon/pictograms-react@10.7.0`}</h3>
    <h4 {...{
      "id": "bug-fixes-2"
    }}>{`Bug fixes`}</h4>
    <ul>
      <li parentName="ul">{`fix: update pictograms dep (#4105) (`}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/commit/fc1dde65f"
        }}><inlineCode parentName="a">{`fc1dde65f`}</inlineCode></a>{`)`}</li>
    </ul>
    <h4 {...{
      "id": "housekeeping-3"
    }}>{`Housekeeping`}</h4>
    <ul>
      <li parentName="ul">{`chore(release): update package versions (#4265) (`}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/commit/346e93543"
        }}><inlineCode parentName="a">{`346e93543`}</inlineCode></a>{`)`}</li>
      <li parentName="ul">{`chore(release): update package versions (#4139) (`}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/commit/1a435757c"
        }}><inlineCode parentName="a">{`1a435757c`}</inlineCode></a>{`)`}</li>
      <li parentName="ul">{`chore: make pictogram packages public (#4098) (`}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/commit/ca4b18e00"
        }}><inlineCode parentName="a">{`ca4b18e00`}</inlineCode></a>{`)`}</li>
    </ul>
    <h3 {...{
      "id": "carbonpictograms1070"
    }}>{`@carbon/pictograms@10.7.0`}</h3>
    <h4 {...{
      "id": "new-features-3"
    }}>{`New features`}</h4>
    <ul>
      <li parentName="ul">{`feat(pictograms): add pictograms and update metadata (#4041) (`}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/commit/a8379f7d8"
        }}><inlineCode parentName="a">{`a8379f7d8`}</inlineCode></a>{`)`}</li>
    </ul>
    <h4 {...{
      "id": "bug-fixes-3"
    }}>{`Bug fixes`}</h4>
    <ul>
      <li parentName="ul">{`fix(pictograms): Update metadata.yml (#4093) (`}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/commit/31e74266f"
        }}><inlineCode parentName="a">{`31e74266f`}</inlineCode></a>{`)`}</li>
    </ul>
    <h4 {...{
      "id": "housekeeping-4"
    }}>{`Housekeeping`}</h4>
    <ul>
      <li parentName="ul">{`chore(release): update package versions (#4265) (`}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/commit/346e93543"
        }}><inlineCode parentName="a">{`346e93543`}</inlineCode></a>{`)`}</li>
      <li parentName="ul">{`chore(release): update package versions (#4139) (`}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/commit/1a435757c"
        }}><inlineCode parentName="a">{`1a435757c`}</inlineCode></a>{`)`}</li>
      <li parentName="ul">{`chore(pictograms): update metadata for milan and mexico-city as… (#4102) (`}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/commit/10378d578"
        }}><inlineCode parentName="a">{`10378d578`}</inlineCode></a>{`)`}</li>
      <li parentName="ul">{`chore: make pictogram packages public (#4098) (`}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/commit/ca4b18e00"
        }}><inlineCode parentName="a">{`ca4b18e00`}</inlineCode></a>{`)`}</li>
    </ul>
    <h3 {...{
      "id": "carbon-components-react770"
    }}>{`carbon-components-react@7.7.0`}</h3>
    <h4 {...{
      "id": "new-features-4"
    }}>{`New features`}</h4>
    <ul>
      <li parentName="ul">{`feat(toggle): add aria-label and label text props to skeletons (#4204) (`}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/commit/fef8eb9f4"
        }}><inlineCode parentName="a">{`fef8eb9f4`}</inlineCode></a>{`)`}</li>
      <li parentName="ul">{`feat(components,themes): add enable-css-custom-properties feature flag (#4100) (`}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/commit/d8d93e366"
        }}><inlineCode parentName="a">{`d8d93e366`}</inlineCode></a>{`)`}</li>
      <li parentName="ul">{`feat(tile): support ignoring click events (#4059) (`}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/commit/1c7ad53b4"
        }}><inlineCode parentName="a">{`1c7ad53b4`}</inlineCode></a>{`)`}</li>
      <li parentName="ul">{`feat(ui-shell): add alternative behaviours (#3990) (`}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/commit/a53796102"
        }}><inlineCode parentName="a">{`a53796102`}</inlineCode></a>{`)`}</li>
      <li parentName="ul">{`feat: add Carbon theme switcher to React storybook (#3989) (`}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/commit/9f2894f29"
        }}><inlineCode parentName="a">{`9f2894f29`}</inlineCode></a>{`)`}</li>
      <li parentName="ul">{`feat(TooltipDefinition): support custom trigger element class names (#3995) (`}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/commit/59d0e3cdc"
        }}><inlineCode parentName="a">{`59d0e3cdc`}</inlineCode></a>{`)`}</li>
      <li parentName="ul">{`feat(link): introduce inline variant (#3859) (`}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/commit/f167fd6fb"
        }}><inlineCode parentName="a">{`f167fd6fb`}</inlineCode></a>{`)`}</li>
      <li parentName="ul">{`feat(TooltipIcon): auto generate default IDs (#3954) (`}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/commit/a18e7348f"
        }}><inlineCode parentName="a">{`a18e7348f`}</inlineCode></a>{`)`}</li>
      <li parentName="ul">{`feat(data-table): add sticky header to React data table (#3876) (`}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/commit/9b8a4619f"
        }}><inlineCode parentName="a">{`9b8a4619f`}</inlineCode></a>{`)`}</li>
      <li parentName="ul">{`feat(FileUploader): add drag and drop file uploader (#3872) (`}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/commit/8a4fae72c"
        }}><inlineCode parentName="a">{`8a4fae72c`}</inlineCode></a>{`)`}</li>
      <li parentName="ul">{`feat(TooltipIcon): port vanilla WCAG 2.1 fixes (#3842) (`}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/commit/aeacad436"
        }}><inlineCode parentName="a">{`aeacad436`}</inlineCode></a>{`)`}</li>
    </ul>
    <h4 {...{
      "id": "bug-fixes-4"
    }}>{`Bug fixes`}</h4>
    <ul>
      <li parentName="ul">{`fix(accordion): top align accordion headings (#4125) (`}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/commit/1974a1e86"
        }}><inlineCode parentName="a">{`1974a1e86`}</inlineCode></a>{`)`}</li>
      <li parentName="ul">{`fix(DatePicker): improve keyboard navigation (#4101) (`}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/commit/40da1fade"
        }}><inlineCode parentName="a">{`40da1fade`}</inlineCode></a>{`)`}</li>
      <li parentName="ul">{`fix(tooltip): conditionally set aria-describedby on open (#4110) (`}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/commit/39640c529"
        }}><inlineCode parentName="a">{`39640c529`}</inlineCode></a>{`)`}</li>
      <li parentName="ul">{`fix(icon-build-helpers): remove convertPathData minification ru… (#4107) (`}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/commit/81d69760a"
        }}><inlineCode parentName="a">{`81d69760a`}</inlineCode></a>{`)`}</li>
      <li parentName="ul">{`fix(ExpandableTile): resolves VO issues (#4055) (`}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/commit/02415c815"
        }}><inlineCode parentName="a">{`02415c815`}</inlineCode></a>{`)`}</li>
      <li parentName="ul">{`fix(tooltip): add aria-labelledby and aria-describedby properties (#4073) (`}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/commit/c352d315a"
        }}><inlineCode parentName="a">{`c352d315a`}</inlineCode></a>{`)`}</li>
      <li parentName="ul">{`fix(Modal): remove scroller class on unmount (#4066) (`}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/commit/be8980767"
        }}><inlineCode parentName="a">{`be8980767`}</inlineCode></a>{`)`}</li>
      <li parentName="ul">{`fix(ComboBox): resolves DAP violations (#4028) (`}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/commit/b0af77524"
        }}><inlineCode parentName="a">{`b0af77524`}</inlineCode></a>{`)`}</li>
      <li parentName="ul">{`fix(date-picker): update month UI upon manual input (#3979) (`}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/commit/cccb54c56"
        }}><inlineCode parentName="a">{`cccb54c56`}</inlineCode></a>{`)`}</li>
      <li parentName="ul">{`fix(InlineLoading): support richer description (#3951) (`}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/commit/605502a88"
        }}><inlineCode parentName="a">{`605502a88`}</inlineCode></a>{`)`}</li>
      <li parentName="ul">{`fix(TileGroup): Wrap RadioTiles inside TileGroup (#3947) (`}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/commit/becfd1939"
        }}><inlineCode parentName="a">{`becfd1939`}</inlineCode></a>{`)`}</li>
      <li parentName="ul">{`fix(table-batch-action): remove default iconDescription, add proptype check, update stories (#3928) (`}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/commit/765e7ece0"
        }}><inlineCode parentName="a">{`765e7ece0`}</inlineCode></a>{`)`}</li>
      <li parentName="ul">{`fix(InlineLoading): fix prop type (#3933) (`}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/commit/5ebdd2d3b"
        }}><inlineCode parentName="a">{`5ebdd2d3b`}</inlineCode></a>{`)`}</li>
      <li parentName="ul">{`fix(TableToolbarAction): adds forwardRef so focus management works as expected (#3918) (`}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/commit/6dcabd4cf"
        }}><inlineCode parentName="a">{`6dcabd4cf`}</inlineCode></a>{`)`}</li>
    </ul>
    <h4 {...{
      "id": "documentation-1"
    }}>{`Documentation`}</h4>
    <ul>
      <li parentName="ul">{`docs(react): upgrade storybook to 5.2 (#4192) (`}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/commit/bb682418b"
        }}><inlineCode parentName="a">{`bb682418b`}</inlineCode></a>{`)`}</li>
      <li parentName="ul">{`docs(text-input): set display name and props for variations (#4190) (`}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/commit/6bd123ccb"
        }}><inlineCode parentName="a">{`6bd123ccb`}</inlineCode></a>{`)`}</li>
      <li parentName="ul">{`docs(accordion): add displayname for select component proptable (#4186) (`}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/commit/687da2f84"
        }}><inlineCode parentName="a">{`687da2f84`}</inlineCode></a>{`)`}</li>
      <li parentName="ul">{`docs(inline-loading): update mocksubmission example to have proptable (#4182) (`}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/commit/2e3291761"
        }}><inlineCode parentName="a">{`2e3291761`}</inlineCode></a>{`)`}</li>
      <li parentName="ul">{`docs(radio-button): remove checked knob from story (#4087) (`}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/commit/810498081"
        }}><inlineCode parentName="a">{`810498081`}</inlineCode></a>{`)`}</li>
      <li parentName="ul">{`docs: create so-you’re-going-on-vacation.md (#4029) (`}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/commit/0efa21b82"
        }}><inlineCode parentName="a">{`0efa21b82`}</inlineCode></a>{`)`}</li>
      <li parentName="ul">{`docs(button): add display name in storybook (#3996) (`}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/commit/f00f1ce97"
        }}><inlineCode parentName="a">{`f00f1ce97`}</inlineCode></a>{`)`}</li>
      <li parentName="ul">{`docs(OverflowMenu): use overflow menu example (#3966) (`}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/commit/c6df3cded"
        }}><inlineCode parentName="a">{`c6df3cded`}</inlineCode></a>{`)`}</li>
      <li parentName="ul">{`docs(DataTable): adds with OverflowMenu story (#3956) (`}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/commit/4901bf98c"
        }}><inlineCode parentName="a">{`4901bf98c`}</inlineCode></a>{`)`}</li>
      <li parentName="ul">{`docs(button): update iconDescription prop description (#3924) (`}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/commit/bbc27a4af"
        }}><inlineCode parentName="a">{`bbc27a4af`}</inlineCode></a>{`)`}</li>
    </ul>
    <h4 {...{
      "id": "housekeeping-5"
    }}>{`Housekeeping`}</h4>
    <ul>
      <li parentName="ul">{`chore(release): update package versions (#4265) (`}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/commit/346e93543"
        }}><inlineCode parentName="a">{`346e93543`}</inlineCode></a>{`)`}</li>
      <li parentName="ul">{`chore(release): update package versions (#4262) (`}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/commit/8983ed788"
        }}><inlineCode parentName="a">{`8983ed788`}</inlineCode></a>{`)`}</li>
      <li parentName="ul">{`chore(react): add component name to deprecation warning for toolbar (#4229) (`}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/commit/dd2c1357c"
        }}><inlineCode parentName="a">{`dd2c1357c`}</inlineCode></a>{`)`}</li>
      <li parentName="ul">{`test(dropdown): assign mockProps before each title test (#4150) (`}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/commit/d2f1562e6"
        }}><inlineCode parentName="a">{`d2f1562e6`}</inlineCode></a>{`)`}</li>
      <li parentName="ul">{`test(combo-box): add required id to mockProps before each test (#4169) (`}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/commit/faf492993"
        }}><inlineCode parentName="a">{`faf492993`}</inlineCode></a>{`)`}</li>
      <li parentName="ul">{`chore(release): update package versions (#4139) (`}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/commit/1a435757c"
        }}><inlineCode parentName="a">{`1a435757c`}</inlineCode></a>{`)`}</li>
      <li parentName="ul">{`chore(react): add deprecation warning to Toolbar/ToolbarSearch (#4097) (`}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/commit/2e4ee8fca"
        }}><inlineCode parentName="a">{`2e4ee8fca`}</inlineCode></a>{`)`}</li>
      <li parentName="ul">{`test(react): add toHaveNoViolations matcher (#3927) (`}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/commit/4c0675682"
        }}><inlineCode parentName="a">{`4c0675682`}</inlineCode></a>{`)`}</li>
      <li parentName="ul">{`chore(project): force react resolutions (#3917) (`}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/commit/5285ccbc4"
        }}><inlineCode parentName="a">{`5285ccbc4`}</inlineCode></a>{`)`}</li>
      <li parentName="ul">{`chore(react): update storybook and react (#3891) (`}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/commit/548a04168"
        }}><inlineCode parentName="a">{`548a04168`}</inlineCode></a>{`)`}</li>
    </ul>
    <h3 {...{
      "id": "carbonthemes1070"
    }}>{`@carbon/themes@10.7.0`}</h3>
    <h4 {...{
      "id": "new-features-5"
    }}>{`New features`}</h4>
    <ul>
      <li parentName="ul">{`feat(themes): add type tokens to themes (`}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/commit/580955f54"
        }}><inlineCode parentName="a">{`580955f54`}</inlineCode></a>{`)`}</li>
      <li parentName="ul">{`feat(components,themes): add enable-css-custom-properties feature flag (#4100) (`}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/commit/d8d93e366"
        }}><inlineCode parentName="a">{`d8d93e366`}</inlineCode></a>{`)`}</li>
      <li parentName="ul">{`feat(themes): update build step to emit prefixed custom properties (`}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/commit/0b0599e6e"
        }}><inlineCode parentName="a">{`0b0599e6e`}</inlineCode></a>{`)`}</li>
      <li parentName="ul">{`feat(tokens): add danger, text05, update text02 (#3962) (`}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/commit/36113ce67"
        }}><inlineCode parentName="a">{`36113ce67`}</inlineCode></a>{`)`}</li>
    </ul>
    <h4 {...{
      "id": "bug-fixes-5"
    }}>{`Bug fixes`}</h4>
    <ul>
      <li parentName="ul">{`fix(themes): delay token or map initialization (`}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/commit/225b4911b"
        }}><inlineCode parentName="a">{`225b4911b`}</inlineCode></a>{`)`}</li>
      <li parentName="ul">{`fix(themes): remove duplicate danger token (`}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/commit/9f37efa5b"
        }}><inlineCode parentName="a">{`9f37efa5b`}</inlineCode></a>{`)`}</li>
      <li parentName="ul">{`fix(button): add higher contrast danger button color token to all themes (#4037) (`}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/commit/7c8fd431a"
        }}><inlineCode parentName="a">{`7c8fd431a`}</inlineCode></a>{`)`}</li>
      <li parentName="ul">{`fix(themes): update disabled-02 value (#3980) (`}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/commit/401107df3"
        }}><inlineCode parentName="a">{`401107df3`}</inlineCode></a>{`)`}</li>
    </ul>
    <h4 {...{
      "id": "housekeeping-6"
    }}>{`Housekeeping`}</h4>
    <ul>
      <li parentName="ul">{`chore(release): update package versions (#4265) (`}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/commit/346e93543"
        }}><inlineCode parentName="a">{`346e93543`}</inlineCode></a>{`)`}</li>
      <li parentName="ul">{`chore(release): update package versions (#4262) (`}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/commit/8983ed788"
        }}><inlineCode parentName="a">{`8983ed788`}</inlineCode></a>{`)`}</li>
      <li parentName="ul">{`chore(release): update package versions (#4139) (`}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/commit/1a435757c"
        }}><inlineCode parentName="a">{`1a435757c`}</inlineCode></a>{`)`}</li>
      <li parentName="ul">{`test(themes): update themes test (`}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/commit/c02493166"
        }}><inlineCode parentName="a">{`c02493166`}</inlineCode></a>{`)`}</li>
      <li parentName="ul">{`chore(project): sync generated files (`}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/commit/f65266835"
        }}><inlineCode parentName="a">{`f65266835`}</inlineCode></a>{`)`}</li>
      <li parentName="ul">{`chore(themes): remove comment block from theme-maps (`}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/commit/5b26e6dfc"
        }}><inlineCode parentName="a">{`5b26e6dfc`}</inlineCode></a>{`)`}</li>
      <li parentName="ul">{`chore(project): check-in generated files (`}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/commit/9dab26827"
        }}><inlineCode parentName="a">{`9dab26827`}</inlineCode></a>{`)`}</li>
      <li parentName="ul">{`refactor(themes): move `}<strong parentName="li">{`tests`}</strong>{` out of scss dir to prevent copy (`}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/commit/60e737bb1"
        }}><inlineCode parentName="a">{`60e737bb1`}</inlineCode></a>{`)`}</li>
      <li parentName="ul">{`refactor(themes): split out tests and update import paths (`}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/commit/9d9e7df53"
        }}><inlineCode parentName="a">{`9d9e7df53`}</inlineCode></a>{`)`}</li>
      <li parentName="ul">{`refactor(themes): update themes build and output to generated (`}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/commit/4e3264235"
        }}><inlineCode parentName="a">{`4e3264235`}</inlineCode></a>{`)`}</li>
    </ul>
    <h3 {...{
      "id": "carbontype1060"
    }}>{`@carbon/type@10.6.0`}</h3>
    <h4 {...{
      "id": "new-features-6"
    }}>{`New features`}</h4>
    <ul>
      <li parentName="ul">{`feat(type): add support for emitting custom properties (`}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/commit/a36bb199c"
        }}><inlineCode parentName="a">{`a36bb199c`}</inlineCode></a>{`)`}</li>
      <li parentName="ul">{`feat(type): add token reference (`}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/commit/41e2fc3b7"
        }}><inlineCode parentName="a">{`41e2fc3b7`}</inlineCode></a>{`)`}</li>
    </ul>
    <h4 {...{
      "id": "bug-fixes-6"
    }}>{`Bug fixes`}</h4>
    <ul>
      <li parentName="ul">{`fix(type): remove italic from helper text 01 (#4004) (`}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/commit/a4e1ee18c"
        }}><inlineCode parentName="a">{`a4e1ee18c`}</inlineCode></a>{`)`}</li>
      <li parentName="ul">{`fix(form): remove italic from helper text (#3977) (`}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/commit/dfbeb8dce"
        }}><inlineCode parentName="a">{`dfbeb8dce`}</inlineCode></a>{`)`}</li>
    </ul>
    <h4 {...{
      "id": "housekeeping-7"
    }}>{`Housekeeping`}</h4>
    <ul>
      <li parentName="ul">{`chore(release): update package versions (#4265) (`}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/commit/346e93543"
        }}><inlineCode parentName="a">{`346e93543`}</inlineCode></a>{`)`}</li>
      <li parentName="ul">{`chore(release): update package versions (#4139) (`}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/commit/1a435757c"
        }}><inlineCode parentName="a">{`1a435757c`}</inlineCode></a>{`)`}</li>
      <li parentName="ul">{`test(type): update test snapshots (`}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/commit/a2a51058f"
        }}><inlineCode parentName="a">{`a2a51058f`}</inlineCode></a>{`)`}</li>
      <li parentName="ul">{`chore(project): sync generated files (`}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon/commit/f65266835"
        }}><inlineCode parentName="a">{`f65266835`}</inlineCode></a>{`)`}</li>
    </ul>
    <h2 {...{
      "id": "archive"
    }}>{`Archive`}</h2>
    <p>{`See Carbon’s `}<a parentName="p" {...{
        "href": "https://github.com/carbon-design-system/carbon/releases"
      }}>{`GitHub release log`}</a>{` for the full archive of version releases and past changelogs.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      